(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dh-acilir-metin"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dh-acilir-metin')) {
    customElements.define('dh-acilir-metin', class extends HTMLElement {
      connectedCallback() {
        const metin = this.querySelector('.dh-acilir__metin');
        const dugme = this.querySelector('.dh-acilir__dugme');
        if (!metin || !dugme) return;
        if (metin.scrollHeight <= metin.clientHeight + 2) {
          this.dataset.kisa = '';
          return;
        }
        dugme.hidden = false;
        dugme.addEventListener('click', () => {
          const acik = this.toggleAttribute('data-acik');
          dugme.setAttribute('aria-expanded', String(acik));
          dugme.textContent = acik ? 'Kapat' : 'Devamı';
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
